import { Card } from "antd"
import { CardProps } from "antd/lib";
import React, { CSSProperties } from "react"

const defaultStyle: CSSProperties = {
  height: '100%',
};

const defaultHeaderStyle: CSSProperties = {
  padding: '0 12px',
  background: '#939393',
  color: '#000000',
};
const defaultBodyStyle: CSSProperties = {
    padding: '12px',
    height: '100%',
}

/**
 * This card should contain the bin details for Auto-Bin/Dri-Stack/Premier and Premier+, and be used on the home / bin-fleet pages
 */
export const BinDetailsStyledCard = (props: CardProps) => {

    const mergedHeaderStyle = { ...defaultHeaderStyle, ...props.styles?.header };
    const mergedBodyStyle   = { ...defaultBodyStyle,   ...props.styles?.body   };
    const mergedContainerStyle = { ...defaultStyle, ...props.style };

    return <Card
    {...props}
    style={mergedContainerStyle}
    styles={{
        ...props.styles,
        header: mergedHeaderStyle,
        body: mergedBodyStyle,
    }}
    >
        {props.children}
    </Card>
}